import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import colors from "/styles/colors";
import { StyledButtonLinkComponent } from "./button-link-component.scss";
import SpinnerComponent from "/components/enhancements/spinner/spinner-component";
import { BUTTON_LINK_CLICKED } from "/constants/bigbrain-event-types";
import classnames from "classnames";
import { withRouter } from "next/router";
class ButtonLinkComponent extends PureComponent {
    onClick(e) {
        const { onClickCallback, placement, href } = this.props;
        BigBrain("track", BUTTON_LINK_CLICKED, {
            placement,
            info1: href
        });
        if (onClickCallback) {
            onClickCallback(e);
        }
        return true; // continue the location change
    }
    getUrlParams() {
        const { router } = this.props;
        const searchParams = router.asPath.split(/\?/)[1];
        return "?" + searchParams;
    }
    render() {
        const { className, tabIndex, children, href, target, color, loading, fontSize, textColor, shouldForwardUrlParams } = this.props;
        let hrefWithParamsIfNeeded = href;
        if (shouldForwardUrlParams) {
            hrefWithParamsIfNeeded += this.getUrlParams();
        }
        return /*#__PURE__*/ _jsx(StyledButtonLinkComponent, {
            className: classnames("button-link-component", {
                loading
            }),
            children: loading ? /*#__PURE__*/ _jsx(SpinnerComponent, {
                className: "spinner",
                color: "white",
                size: "24px",
                speed: "slow"
            }) : /*#__PURE__*/ _jsx("a", {
                href: hrefWithParamsIfNeeded,
                target: target,
                tabIndex: tabIndex,
                className: classnames(className, {
                    loading: loading
                }),
                onClick: this.onClick,
                style: {
                    backgroundColor: colors[color],
                    color: colors[textColor],
                    fontSize
                },
                children: children
            })
        });
    }
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
}
ButtonLinkComponent.defaultProps = {
    onClickCallback: null,
    tabIndex: -1,
    className: "",
    color: "brand-pink",
    textColor: "white",
    loading: false
};
export default withRouter(ButtonLinkComponent);
